// import http from './../../../base/api/public'
// let service = require('@/../config/serviceList')
// let sysConfig = require('@/../config/sysConfig')
// let apiPre = sysConfig.apiPre
// service.res = ''
// export default {
//   getCards (params) {
//     console.log('params:' + JSON.stringify(params))
//     return http.requestPost(apiPre + service.res + '/card/getList', params)
//   }
// }
// 导入基本公共资源
import http from './../../../base/api/public'

let sysConfig = require('@/../config/sysConfig')
let service = require('@/../config/serviceList')
// 定义访问网关的api,分为开发，测试，以及生产环境
let apiPre = sysConfig.apiPre
export default {
  // SIM卡
  getSimCards(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/simCard/getSimCards', params)
  },
  saveOrUpdateSimCard(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPut(apiPre + service.res + '/res/simCard/saveOrUpdateSimCard', params)
  },
  deleteSimCard(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/simCard/deleteSimCard', params)
  },
  getSimCardEnum(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestGet(apiPre + service.res + '/res/simCard/getSimCardEnum', params)
  },
  exportSim(params){
    return http.requestDownloadExcel(apiPre + service.res +'/res/simCard/excel',params)
  }
}



// WEBPACK FOOTER //
// ./src/module/resourceCenter/api/simCardApi.js